import React from 'react';
import Hdr from './shared/Hdr';
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { apiPath, apiPath2 } from "../src/services/apiConfig";

function User() {
  const user = localStorage.getItem('user-info');
  const token = localStorage.getItem('token');
  const usrRole = localStorage.getItem('user-role');
  const userLoginId = localStorage.getItem('LoginId');
  const [displayUser, setDisplayuser] = useState('none');
  const [displayUpdUser, setDisplayUpdUser] = useState('none');
  const [data, setData] = useState([]);
  const [dataStat, setDataStat] = useState();
  const [userName, setUserName] = useState('');
  //  const [address, setAddress] = useState('');
  //  const [phoneNumber, setPhoneNumber] = useState('');
  //  const [email, setEmail] = useState('');
  const [uid, setUID] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('');
  const [verfied, setVerfied] = useState(true);
  const [updUserName, setUserUpdName] = useState('');
  //  const [updAddress, setUpdAddress] = useState('');
  //  const [updPhoneNumber, setPhoneUpdNumber] = useState('');
  //  const [updEmail, setUpdEmail] = useState('');
  const [updRole, setUpdRole] = useState('');
  const [userId, setUserID] = useState('');
  // const [updPassword, setUpdPassword] = useState('');
  // const [uidErr, setUIDErr] = useState('');
  const [pwdErr, setPwdErr] = useState('');
  // const [Err, SetErr] = useState([]);
  // const ErrString = "";
  const [show, setShow] = useState('none');
  const [oldPw, setOldPw] = useState('')
  const [newPw, setNewPw] = useState('')
  const [cnfPw, setCnfPw] = useState('')

  let txt = "";


  useEffect(() => {
    getUser()
  }, [])

  function closeModalHandler() {
    setShow('none');
  }

  function ResetPassWord(id) {
    alert('Reset PW')
  }

  function openUser() {
    setDisplayuser('block')
  }

  function openResetPw() {
    setShow(true)
    setShow('block');
  }

  function closeUser() {
    setDisplayuser('none')
  }

  function openUpdUser() {
    setDisplayUpdUser('block')
  }

  function closeUpdUser() {
    setDisplayUpdUser('none')
  }

  async function updateUser(id) {

    let result = await fetch(apiPath + "users/" + id, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "id": id,
        "userId": id,
        "name": updUserName,
        "role": updRole
      })
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getUser()
  }

  async function deleteUser(id) {

    let result = await fetch(apiPath + "users/" + id, {
      method: 'DELETE',
      headers: {
        "Authorization": `Bearer ${token}`
      },
    });
    result = await result.json();

    showSwal(result.success, result.message)

    getUser()
  }



  async function updateOperation(id) {
    //alert(id)

    let result = await fetch(apiPath + "users/" + id,
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },

      });

    result = await result.json();

    setUpdRole(result.data.roleId[0]);
    setUserUpdName(result.data.userName);
    //    setUpdEmail(result.data.userEmail);
    setUserID(result.data.userId);
    openUpdUser();
  }


  function deleteOperation(id) {

    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          //        alert(usrRole)
          deleteUser(id);
        }
        else {
          swal("Your record is safe!");
        }

      });
  }


  //* LIST OF ALL USER (for initial screen)*/ 

  async function getUser() {
    let result = await fetch(apiPath + "users",
      {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })
    result = await result.json();

    setDataStat(result.success);
    setData(result.data);

    if (result.success === true) {
      setData(result.data);
    } else { setData([]) }
  }

  {/*
  function uidHandler(e) {
    setUIDErr('');
    e.preventDefault()
    let item = e.target.value
    if (!item) {
      setUIDErr("required")
    } else {
      setUID(item)
    }
  }
*/}

  function verifyUser() {
    //      alert('Verify')
    setPwdErr('');
    if (password !== confirmPassword) {
      setPwdErr('Both Password not same');
      return
    }
    else {
      setVerfied(true)
      addUser()
    }
  }

  //*ADD A NEW USER*/ 
  async function addUser() {

    if (verfied) {

      let result = await fetch(apiPath + "users", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          "name": userName,
          "email": uid,
          "password": password,
          "password_confirmation": confirmPassword,
          "role": role
        })
      });
      result = await result.json();

      //      if (result.success) { }
      //      else {
      //        SetErr(result.data);
      //      }

      showSwal(result.success, result.message)
      getUser()
    }
  }

  function ResetPwOperation(id) {

    swal({
      title: "Are you sure?",
      text: "Once reset, you are unable to open by your old password!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          ResetPassWord(id);
        }
        else {
          swal("Your record is safe!");
        }
      }
      );
  }

  //*RESET PASSWORD OF EXISTING USER*/ 
  async function ResetPassword() {

    let id = { userLoginId }
    //alert (id.userLoginId+", "+oldPw+", "+newPw+", "+cnfPw)

    let result = await fetch(apiPath2 + "changepassword/" + id, {
      method: 'PATCH',
      headers: {
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify({
        "password_old": newPw,
        "password": newPw,
        "password_confirmation": cnfPw
      })
    });
    result = await result.json();
    console.warn(result);

    showSwal(result.success, result.message)
  }


  function showSwal(stat, txt) {
    if (stat === true) {
      swal({
        title: "Success!",
        text: txt,
        icon: "success",
        button: "OK!",
      });
    } else {
      swal({
        title: "Fail!",
        text: txt,
        icon: "error",
        button: "OK!",
      });
    }
  }

  return (

    <div style={{ 'height': '90vh' }}>
      <Hdr />
      <div className="row p16">
        <div className="c12-l-8">
          <h3 className="" >ADS Hospital - User : {user}</h3>
        </div>
        <div className="c12-l-4 pr32 ">
          <p className="medium right">Role : {usrRole}</p>

          <p onClick={() => openResetPw()} className="medium right" style={{ 'color': 'red', cursor: 'pointer' }}><u>Reset Password</u></p>
        </div>
      </div>

      <div className="row p16" style={{ 'height': '90%' }}>
        <div className=" c12-l-12 cont__content p4" style={{ 'height': '100%' }}>
          <div className="row p32">
            <div className="c12-l-3">
              <h4 className="wide">User Management</h4>
            </div>
            <div className="c12-l-7"></div>
            <div className="c12-l-2">
              <button onClick={openUser} type="button" name="button"
                className="btn solid round">Create User</button>
            </div>
          </div>

          <div className="row mt16" >
            <div className="c12-l-12">
              <table style={{ 'height': '500px', 'overflowY': 'scroll', 'overflowX': 'scroll', 'display': 'block' }}>
                <thead>
                  <tr>
                    <th className="th-border right" width="15%">User Id</th>
                    <th className="th-border left" width="45%">Name</th>
                    <th className="th-border left" width="20%">email</th>
                    <th className="th-border left" width="20%">User Role</th>
                    <th className="th-border" width="10%">Edit</th>
                    <th className="th-border" width="10%">Reset</th>
                    <th className="th-border" width="10%">Delete</th>
                  </tr>
                </thead>
                <tbody >
                  {
                    (dataStat === true ?
                      (
                        data.map((item, index) =>
                          <tr className="tr-border" key={index}>
                            <td className="center">{item.userId}</td>
                            <td className="">{item.userName}</td>
                            <td className="">{item.userEmail}</td>
                            <td className="">{item.roleName}</td>
                            <td onClick={() => { updateOperation(item.userId) }} className="center"><img src={require('./asset/images/adm_edit.png')} alt="" /></td>
                            <td onClick={() => { ResetPwOperation(item.userId) }} className="center"><img src={require('./asset/images/adm_unlock.png')} alt="" /></td>
                            <td onClick={() => { deleteOperation(item.userId) }} className="center"><img src={require('./asset/images/adm_del.png')} alt="" /></td>
                          </tr>
                        ))
                      : <tr><td>No data</td></tr>)
                  }
                </tbody>
              </table>
            </div>
          </div>

          {/* SCREEN FROM ADDING NEW USER */}

          <div id="newdept" style={{ 'display': displayUser }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUser}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Add User</h2>

                  <input type="text" className="box small"
                    placeholder="email" onChange={(e) => setUID(e.target.value)} />

                  <input type="text" className="box small" autoComplete="off"
                    placeholder="Name of the user" onChange={(e) => setUserName(e.target.value)} />

                  <input type="text" className="box small"
                    placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
                  <p style={{ 'color': 'red', 'fontSize': '0.65rem' }}>{pwdErr}</p>

                  <input type="password" className="box small"
                    placeholder="confirm password" onChange={(e) => setConfirmPassword(e.target.value)} />

                  <p style={{ 'fontSize': '0.75rem' }}>user role</p>
                  <select className="custom-select" onChange={(e) => setRole(e.target.value)}>
                    <option value="1" >Super Admin</option>
                    <option value="2" >Admin</option>
                    <option value="3" >operator</option>
                    <option value="4" >Guest</option>
                  </select>

                  <button onClick={verifyUser} type="button"
                    className="btn solid round">Add User</button>
                </div>
              </div>
            </form>
          </div>

          {/* SCREEN FROM UPDTAE EXISTING USER */}

          <div id="newdept" style={{ 'display': displayUpdUser }} className="cont__new-dept">
            <form className="" action="" method="">
              <div className="row">
                <div className="c12-l-11"></div>
                <div className="c12-l-1 center">
                  <p onClick={closeUpdUser}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
                </div>
              </div>

              <div className="row mt32">
                <div className="c12-l-12">
                  <h2>Edit User</h2><br /><br />

                  <input type="hidden" value={userId} />

                  <input type="text" className="box small"
                    placeholder="Name of the user" onChange={(e) => setUserUpdName(e.target.value)}
                    value={updUserName} />

                  <p style={{ 'fontSize': '0.75rem' }}>user role</p>
                  <select className="custom-select" onChange={(e) => setUpdRole(e.target.value)} value={updRole}>
                    <option value="1" >Super Admin</option>
                    <option value="2" >Admin</option>
                    <option value="3" >operator</option>
                    <option value="4" >Guest</option>
                  </select>

                  <button onClick={() => { updateUser(userId) }} type="button"
                    className="btn solid round">Update User</button>
                </div>
              </div>
            </form>
          </div>

          {/* RESET PW */}

          <div className='modal-content' style={{ 'display': show }} >
            <div className="modal-wrapper"></div>

            <div className="modal-container">

              <div className="modal-header">
                <h3>Change of Password</h3>
                <p onClick={closeModalHandler}><img src={require('./asset/images/adm_close.png')} alt="" width="24px" height="24px" /></p>
              </div>

              <div className="modal-body">

                <input type="password" className="box small"
                  placeholder="Old Password" onChange={(e) => setOldPw(e.target.value)} />

                <input type="password" className="box small"
                  placeholder="New Password" onChange={(e) => setNewPw(e.target.value)} />

                <input type="password" className="box small"
                  placeholder="Confirm Password" onChange={(e) => setCnfPw(e.target.value)} />

                <br />
                <button onClick={ResetPassword} type="button" name="button"
                  className="btn solid round">Change Password</button>

                <button onClick={closeModalHandler} type="button"
                  className="btn solid round" style={{ 'background': '#DD501D', 'outline': 'none' }}>Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default User;
